// src/Components/PopupSidebar.tsx
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import authService from "../services/authService"; // Import του authService

type PopupSidebarProps = {
  onHoverChange?: (hovered: boolean) => void;
};

const PopupSidebar: React.FC<PopupSidebarProps> = ({ onHoverChange }) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
    if (onHoverChange) onHoverChange(true); // Ενημερώνουμε το Layout
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    if (onHoverChange) onHoverChange(false); // Ενημερώνουμε το Layout
  };

  // Handler για την Αποσύνδεση
  const handleLogout = () => {
    authService.logout(); // Καθαρίζει το localStorage και κάνει redirect στο /login
  };

  const navLinkClass = ({ isActive }: { isActive: boolean }) =>
    `flex items-center gap-4 p-4 rounded-lg transition-all ${
      isActive ? "bg-dark text-white" : "hover:bg-lightprimary text-gray-900"
    }`;

  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className={`h-screen bg-primary p-5 transition-all duration-300 ease-in-out fixed left-0 top-0 z-50 flex flex-col ${
        isHovered ? "w-64" : "w-20"
      }`}
    >
      {/* Τίτλος Sidebar */}
      <h2
        className={`font-bold mb-10 whitespace-nowrap overflow-hidden transition-all ${
          isHovered ? "text-2xl" : "text-sm"
        }`}
      >
        {isHovered ? "Ηρακλείδης  ο Ταραντινός" : "Η.Τ."}
      </h2>

      {/* Λίστα Πλοήγησης */}
      <ul className="space-y-4">
        {[
          { to: "/", label: "Αρχική", icon: "🏠" },
          { to: "/patients", label: "Ασθενείς", icon: "👤" },
          { to: "/appointments", label: "Ραντεβού", icon: "📅" },
          { to: "/entityManagement", label: "Διαχείριση Καταχωρήσεων", icon: "🗃️" },
          { to: "/statistics", label: "Στατιστικά", icon: "📊" },
          { to: "/settings", label: "Ρυθμίσεις", icon: "⚙️" },
          { to: "/admin", label: "Αρχεία Καταγραφών", icon: "🛡️" },
        ].map((item) => (
          <li key={item.to}>
            <NavLink to={item.to} className={navLinkClass}>
              <span className="text-xl">{item.icon}</span>
              <span className={`${isHovered ? "block" : "hidden"}`}>
                {item.label}
              </span>
            </NavLink>
          </li>
        ))}
      </ul>

      {/* Κουμπί Αποσύνδεσης */}
      <div className="mt-auto pt-4 border-t border-teal-700">
        <button
          onClick={handleLogout} // ✅ Καλούμε τη συνάρτηση handleLogout
          className={`flex items-center gap-4 p-4 rounded-lg transition-all w-full hover:bg-red-500 text-gray-900 hover:text-white`}
        >
          <span className="text-xl">🚪</span>
          <span className={`${isHovered ? "block" : "hidden"}`}>
            Αποσύνδεση
          </span>
        </button>
      </div>
    </div>
  );
};

export default PopupSidebar;
